import { StudySession } from '../types/Study';

export const checkIfStudySessionIsComplete = (studySession: StudySession) => {
  if (studySession.isUsingFlashcards) {
    if (studySession.completedFlashcardCount < studySession.flashcardCount) {
      return false;
    }
  }
  if (studySession.isUsingQbank) {
    if (
      studySession.vignetteCorrectCount +
        studySession.vignetteIncorrectCount +
        studySession.vignetteOmittedCount <
      studySession.vignetteCount
    ) {
      return false;
    }
  }
  return true;
};
